import type { UserChatState } from './types';

export const initialState: UserChatState = {
  data: null,
  isLoading: false,
  error: null,
};
